import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
// import Profile from '../container/profile.js';
import LandingPage from "../../container/Home.jsx";
import { AuthProvider } from "../../Auth.js";
import RegistrationForm from "../../app/Register.jsx";
import LoginForm from "../../app/Login-Form.jsx";
import PrivateRoute from "./PrivateRoute.js";
import Login from "../../container/Login.jsx";
import ProfilePage from "../../container/Profile.jsx";
import AdminPage from "../../container/Admin.jsx";
import ExplorePage from "../../container/Explore.jsx";
import DetailRentalCard from "../../components/explore/DetailRental.jsx";

class Router extends Component {
  render() {
    return (
      <AuthProvider>
        <div>
          <Route path="/admin" component={AdminPage}/>
          <Route exact path="/" component={LandingPage} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/register" component={RegistrationForm} />
          <Route exact path="/profil/:id" component={ProfilePage}/>
          <PrivateRoute exact path="/welcome" component={LandingPage} />
          <Route exact path="/explore" component={ExplorePage} />

          <Route exact path="/explore/:id" component={DetailRentalCard} />
          {/* <Route exact path="/profile" component={Profile}/> */}
        </div>
      </AuthProvider>
    );
  }
}
export default Router;
